<template>
    <div class="index-content">
        <!-- Hero Section / Application Showcase -->
        <el-row type="flex" justify="center" class="hero-section">
            <el-col :span="24">
                <el-card class="showcase-card" :body-style="{ padding: '0px' }" shadow="hover">
                    <div class="image-container">
                        <img src="../assets/images/cover.png" class="main-image" alt="Search++ Application Showcase">
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <!-- Pricing / Specifications Section -->
        <h2 class="section-title">{{ $t('home.specTitle') }}</h2>
        <el-row :gutter="20" type="flex" justify="start" class="spec-row">
            <el-col :xs="24" :sm="12" :md="8" v-for="itemSpec in spec" :key="itemSpec.id" class="spec-col">
                <el-card class="spec-card" shadow="always" :class="{ 'spec-card-link': itemSpec.linkTo }">
                    <div slot="header" class="card-header">
                        <i :class="itemSpec.icon || 'el-icon-monitor'" :style="itemSpec.color"></i>
                        <span class="version-name">{{ itemSpec.name }}</span>
                    </div>
                    <div class="card-body">
                        <div class="spec-item">
                            <i class="el-icon-cpu"></i>
                            <span class="spec-label">OS:</span> {{ itemSpec.OS }}
                        </div>
                        <div class="spec-item">
                            <i class="el-icon-connection"></i>
                            <span class="spec-label">Arch:</span> {{ itemSpec.Bit }}
                        </div>
                        <div class="spec-item" v-if="itemSpec.version">
                            <i class="el-icon-refresh"></i>
                            <span class="spec-label">Version:</span> {{ itemSpec.version }}
                        </div>
                        <div class="price-tag">
                            <el-tag effect="dark" size="large" :type="itemSpec.priceType" :style="itemSpec.priceStyle">{{ itemSpec.price }}</el-tag>
                        </div>
                        <div class="feature-text">
                            <i class="el-icon-check"></i> {{ itemSpec.feature }}
                        </div>
                        <div v-if="itemSpec.linkTo" class="card-action">
                            <router-link v-if="!itemSpec.external" :to="{ path: itemSpec.linkTo, query: { lang: $lang } }" class="detail-link" :class="{ 'detail-link-mojiscan': itemSpec.linkTo === '/mojiscan' }">{{ $t('home.detailLink') }}</router-link>
                            <a v-else :href="itemSpec.linkTo" class="detail-link">{{ $t('home.detailLink') }}</a>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <!-- Technical Notes -->
        <el-row class="memo-row">
            <el-col :span="24">
                <el-alert
                    :title="$t('home.memoTitle')"
                    type="info"
                    :closable="false"
                    show-icon
                    class="memo-alert">
                    <p v-html="$t('home.memo1')"></p>
                    <p>{{ $t('home.shareware') }}</p>
                </el-alert>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
  data: function () {
    return {
    }
  },
  computed: {
    spec () {
      return this.$t('home.spec')
    }
  }
}
</script>

<style scoped>
.index-content {
    padding: 20px;
}

.hero-section {
    margin-bottom: 40px;
}

.showcase-card {
    border-radius: 12px;
    overflow: hidden;
    border: none;
}

.image-container {
    width: 100%;
    background: #fdfdfd;
}

.main-image {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.5s ease;
}

.main-image:hover {
    transform: scale(1.01);
}

.spec-row {
    margin-bottom: 30px;
    flex-wrap: wrap;
}

.spec-col {
    margin-bottom: 20px;
}

.spec-card {
    border-radius: 12px;
    height: 100%;
    transition: all 0.3s ease;
    border: 1px solid #ebeef5;
}

.spec-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 30px rgba(0,0,0,0.1) !important;
}

.card-header {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: bold;
}

.card-header i {
    margin-right: 12px;
    font-size: 24px;
}

.version-name {
    color: #303133;
}

.card-body {
    padding: 10px 0;
}

.spec-item {
    margin-bottom: 15px;
    font-size: 14px;
    color: #606266;
    display: flex;
    align-items: flex-start;
}

.spec-item i {
    margin-right: 8px;
    color: #909399;
    margin-top: 4px;
}

.spec-label {
    font-weight: bold;
    color: #303133;
    margin-right: 5px;
}

.price-tag {
    margin: 20px 0;
    text-align: center;
}

.price-tag .el-tag {
    font-size: 18px;
    padding: 10px 20px;
    height: auto;
    border-radius: 30px;
}

.feature-text {
    font-size: 14px;
    line-height: 1.6;
    color: #5e6d82;
    background: #f8f9fa;
    padding: 12px;
    border-radius: 8px;
}

.feature-text i {
    color: #67C23A;
    margin-right: 5px;
}

.spec-card-link:hover {
    border-color: #13a06a;
}

.card-action {
    margin-top: 14px;
    text-align: center;
}

.detail-link {
    color: #13a06a;
    font-weight: 600;
    text-decoration: none;
    font-size: 14px;
}

.detail-link:hover {
    text-decoration: underline;
}

.detail-link-mojiscan {
    color: #0c86e8;
}

.memo-row {
    margin-top: 40px;
}

.memo-alert {
    padding: 15px 25px;
    border-radius: 12px;
}

.memo-alert p {
    margin: 5px 0;
    line-height: 1.5;
}

@media (max-width: 768px) {
    .index-content {
        padding: 10px;
    }
    .main-title {
        font-size: 20px;
    }
}
</style>
